/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, AuditReportsGetAodScheduledRunsScheduledRunsForRulePathParams, AuditReportsGetAodScheduledRunsScheduledRunsForRule401, AuditReportsGetAodScheduledRunsScheduledRunsForRule403, AuditReportsGetAodScheduledRunsScheduledRunsForRule404 } from "../models/AuditReportsGetAodScheduledRunsScheduledRunsForRule";

export function getAuditReportsGetAodScheduledRunsScheduledRunsForRuleUrl(ruleId: AuditReportsGetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-runs/scheduled/rules/${ruleId}` as const }
  return res
}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for a specific AOD rule
 * @summary Get scheduled runs for an AOD rule
 * {@link /audit-reports/v1/aod-runs/scheduled/rules/:ruleId}
 */
export async function auditReportsGetAodScheduledRunsScheduledRunsForRule(ruleId: AuditReportsGetAodScheduledRunsScheduledRunsForRulePathParams["ruleId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetAodScheduledRunsScheduledRunsForRuleQueryResponse, ResponseErrorConfig<AuditReportsGetAodScheduledRunsScheduledRunsForRule401 | AuditReportsGetAodScheduledRunsScheduledRunsForRule403 | AuditReportsGetAodScheduledRunsScheduledRunsForRule404>, unknown>({ method : "GET", url : getAuditReportsGetAodScheduledRunsScheduledRunsForRuleUrl(ruleId).url.toString(), ... requestConfig })
  return res.data
}